var map = {
	"./Customer Rejection Inward.png": 1115,
	"./Customer Rejection Outward.png": 1340,
	"./Dashboard.png": 2391,
	"./Delivery Challans.png": 3409,
	"./Items.png": 1095,
	"./Material Inward.png": 1117,
	"./Minimum Stock Report.png": 2671,
	"./Purchase Orders.png": 7987,
	"./Request.png": 2152,
	"./Return.png": 3601,
	"./Suppliers.png": 3800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4790;